import { render, staticRenderFns } from "./MewTokenContainer.vue?vue&type=template&id=4b23b3b0"
import script from "./MewTokenContainer.vue?vue&type=script&lang=js"
export * from "./MewTokenContainer.vue?vue&type=script&lang=js"
import style0 from "./MewTokenContainer.vue?vue&type=style&index=0&id=4b23b3b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports